module.exports = __webpack_public_path__ + "static/img3f-23575813dc0a3e944554fdf73383b880.jpg";